import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/44_bridge/44_bridge"
 * Contains 1 texture(s)
 */
export class Desktop44BridgeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/44_bridge/44_bridge';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '44_bridge.jpg'
    ] as const;
}
